import React from "react";
import { Button, Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import SelectableOption, {
  SelectableOptionGroup,
} from "@dhn/components/molecules/selectable-option";
import ValidationFeedback from "@dhn/components/molecules/validation-feedback";

const IdentityValidationStep = ({
  form,
  inlineErrors,
  identityValidation,
  isValidatingIdentity,
  isValidateDisabled,
  hasSelectedPersonType,
  hasSelectedMedicalType,
  onChange,
  onDocumentNumberChange,
  handleValidateIdentity,
  showInlineError,
}) => {
  const validateButtonStatus = identityValidation.status;
  const shouldShowResetHint = validateButtonStatus === "conflict";
  const validateButtonIcon = isValidatingIdentity
    ? "fa-spinner fa-spin"
    : validateButtonStatus === "validated"
      ? "fa-check-circle"
      : validateButtonStatus === "conflict"
        ? "fa-exclamation-triangle"
        : validateButtonStatus === "error"
          ? "fa-refresh"
          : "fa-search";
  const validateButtonLabel = isValidatingIdentity
    ? "Validando..."
    : validateButtonStatus === "validated"
      ? "Validar de nuevo"
      : validateButtonStatus === "conflict"
        ? "Validar de nuevo"
        : validateButtonStatus === "error"
          ? "Reintentar"
          : "Validar";

  return (
    <>
      <div className="prereg-step-header mt-3">
        <span className="prereg-step-index">Paso 1</span>
        <h6>Tipo de Solicitante y Validación Inicial</h6>
      </div>

      <Card>
        <CardBody>
          <Row form className="align-items-end">
            <Col lg={4} md={6} className="prereg-divided-col">
              <Label className="d-block">
                ¿Es Médico?
                <span className="required-mark"> *</span>
              </Label>
              <SelectableOptionGroup columns={2}>
                <SelectableOption
                  key="is-medical-yes"
                  icon="fa-user-md"
                  title="Sí"
                  inputType="radio"
                  inputName="prereg-is-medical"
                  checked={form.isMedical === true}
                  onChange={() => onChange("isMedical", true)}
                />
                <SelectableOption
                  key="is-medical-no"
                  icon="fa-user"
                  title="No"
                  inputType="radio"
                  inputName="prereg-is-medical"
                  checked={form.isMedical === false}
                  onChange={() => onChange("isMedical", false)}
                />
              </SelectableOptionGroup>
              {showInlineError("isMedical")}
            </Col>

            <Col lg={5} md={6}>
              <Label className="d-block">Personalidad Jurídica</Label>
              <SelectableOptionGroup columns={2}>
                <SelectableOption
                  key="person-type-fisica"
                  icon="fa-id-card-o"
                  title="Persona Física"
                  inputType="radio"
                  inputName="prereg-person-type"
                  checked={form.personType === "FISICA"}
                  onChange={() => onChange("personType", "FISICA")}
                />
                <SelectableOption
                  key="person-type-moral"
                  icon="fa-building-o"
                  title="Persona Moral"
                  inputType="radio"
                  inputName="prereg-person-type"
                  checked={form.personType === "MORAL"}
                  onChange={() => onChange("personType", "MORAL")}
                />
              </SelectableOptionGroup>
              {showInlineError("personType")}
            </Col>

            <Col lg={3} md={12}>
              {(!hasSelectedPersonType || !hasSelectedMedicalType) && (
                <div className="medical-prereg-hint w-100 mb-3">
                  Seleccione tipo de solicitante y personalidad para continuar.
                </div>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>

      {hasSelectedPersonType && hasSelectedMedicalType && (
        <Card className="mt-3">
          <CardBody>
            <Row form className="align-items-end">
              <Col lg={4} md={5} className="prereg-divided-col">
                <Label className="d-block">Tipo de Documento</Label>
                <SelectableOptionGroup columns={1}>
                  <SelectableOption
                    key="document-type"
                    icon={form.personType === "MORAL" ? "fa-building-o" : "fa-id-card-o"}
                    title={form.personType === "MORAL" ? "RNC" : "Cédula"}
                    inputType="radio"
                    inputName="prereg-document-type"
                    checked={
                      form.personType === "MORAL"
                        ? form.documentType === "RNC"
                        : form.documentType === "CEDULA"
                    }
                    onChange={() =>
                      onChange(
                        "documentType",
                        form.personType === "MORAL" ? "RNC" : "CEDULA",
                      )
                    }
                  />
                </SelectableOptionGroup>
              </Col>

              <Col lg={8} md={7}>
                <Label>
                  {form.documentType === "RNC"
                    ? "RNC"
                    : "Cédula"}{" "}
                  <span className="required-mark">*</span>
                </Label>
                <div className="document-lookup-row">
                  <div className="document-lookup-input">
                    <Input
                      invalid={Boolean(inlineErrors.documentNumber)}
                      value={form.documentNumber}
                      inputMode="numeric"
                      maxLength={form.documentType === "RNC" ? 12 : 13}
                      onChange={(event) => onDocumentNumberChange(event.target.value)}
                      placeholder="campo obligatorio"
                    />
                  </div>
                  <Button
                    type="button"
                    color="primary"
                    className="btn-validate py-2"
                    disabled={isValidateDisabled}
                    onClick={handleValidateIdentity}
                  >
                    <i className={`fa ${validateButtonIcon} mr-1`} aria-hidden="true"></i>
                    {validateButtonLabel}
                  </Button>
                </div>
                {showInlineError("documentNumber")}
              </Col>
            </Row>

            {identityValidation.status !== "idle" && (
              <ValidationFeedback className="mt-3" status={identityValidation.status}>
                {identityValidation.message}
                {shouldShowResetHint && (
                  <small className="d-block mt-1">
                    Para validar otra persona, use el botón
                    &nbsp;<strong>Reiniciar formulario</strong>.
                  </small>
                )}
              </ValidationFeedback>
            )}

            {identityValidation.status === "idle" && (
              <ValidationFeedback className="mt-3" status="info">
                Debe validar un número de documento válido para mostrar los pasos 2 y 3.
              </ValidationFeedback>
            )}
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default IdentityValidationStep;
